import { FromTableBaseCollectionFilterRequestBuilder } from './from-table-base-collection-filter-request.builder';
import { CollectionFilterOperator } from '../enums/collection-filter-operator';
import { CollectionFilterRequest } from '../requests/collection-filter.request';
import { isNil, Nillable } from '@web/utils';
import { CollectionFilterKey } from '../../collection/types/collection-filter-key';

export class FromTableTextCollectionFilterRequestBuilder<
  Filter,
> extends FromTableBaseCollectionFilterRequestBuilder<Filter> {
  public equal(): this {
    return this.operator(CollectionFilterOperator.Equal);
  }

  public caseInsensitiveLike(): this {
    return this.operator(CollectionFilterOperator.CaseInsensitiveLike);
  }

  public like(): this {
    return this.operator(CollectionFilterOperator.Like);
  }

  public in(): this {
    return this.operator(CollectionFilterOperator.In);
  }

  public startsWith(): this {
    return this.operator(CollectionFilterOperator.StartsWith);
  }

  public equalFor(property: CollectionFilterKey<Filter>): this {
    return this.equal().property(property);
  }

  public caseInsensitiveLikeFor(property: CollectionFilterKey<Filter>): this {
    return this.caseInsensitiveLike().property(property);
  }

  public likeFor(property: CollectionFilterKey<Filter>): this {
    return this.like().property(property);
  }

  public inFor(property: CollectionFilterKey<Filter>): this {
    return this.in().property(property);
  }

  public startsWithFor(property: CollectionFilterKey<Filter>): this {
    return this.startsWith().property(property);
  }

  public override build(): Nillable<CollectionFilterRequest> {
    this.configureDefaultOperator();

    return super.build();
  }

  private configureDefaultOperator(): void {
    if (!isNil(this._operator)) {
      return;
    }

    this.caseInsensitiveLike();
  }
}
